export default __webpack_public_path__ + "static/brew-top-da590a4b1bf859b3f5e82d6e2b31adc7.png";